var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation pin-t pin-x fixed",class:{
    'navigation-white': _vm.hasBackground
  }},[_c('div',{staticClass:"container mx-auto flex justify-between h-16 items-center px-4"},[_c('a',{staticClass:"logo",attrs:{"href":"/"}},[_c('img',{staticClass:"h-10",attrs:{"src":_vm.logoVariant,"alt":"CodePilot.ai Logo"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }